// extracted by mini-css-extract-plugin
module.exports = {"filter":"FilterColor_filter__19car","title":"FilterColor_title__lY1O-","colors":"FilterColor_colors__D3e1-","item":"FilterColor_item__137Ok","border":"FilterColor_border__zD-cN"};